import Vue from 'vue';
import Component from 'vue-class-component';
import EdCallsInfoPopupComponent from '../ed-calls-info-popup/ed-calls-info-popup.component.vue';
import {_CALLS_STORE, CALLS_EVENTS} from '@/components/calls/values/calls.values';
import {Mixins} from 'vue-property-decorator';
import {CallsSipMixin} from '@/components/calls/services/sip/calls.sip.mixin';
import Moment from 'moment';

@Component({
    components: {
        EdCallsInfoPopupComponent
    }
})
export class EdCallsInfoComponent extends Mixins(CallsSipMixin) {

    public hors: number = 0;
    public mins: number = 0;
    public secs: number = 0;
    public interval: any = null;
    public processing: boolean = false;

    mounted() {
        this.startTime();
    }
    beforeDestroy() {
        clearInterval(this.interval);
    }
    startTime(){
        let startTime = new Date().getTime();
        if (this.call && this.call.startCallUserTz)
            startTime = new Date(this.call.startCallUserTz).getTime();

        this.interval = setInterval(() => {
            const now = new Date().getTime();
            const elapsed = now - startTime;
            this.hors = Math.floor(elapsed / (1000 * 60 * 60));
            this.mins = Math.floor((elapsed % (1000 * 60 * 60)) / (1000 * 60));
            this.secs = Math.floor((elapsed % (1000 * 60)) / 1000);
            this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_LOCAL_TIME, this.secs + '|' + this.mins + '|' + this.hors);
            this.$edEventBus.$emit(CALLS_EVENTS.CALLS_CHANGE_TIME, {hors: this.hors, mins: this.mins, secs: this.secs});
        }, 1000);
    }

    /**
     * Find users on call
     */
     public async click() {
         if(this.processing)return;
         this.processing = true;
         this.spShowProcessing();
         try{
            await this.getAsteriskUserInfo(this.call.classId)
         }catch (e){
            this.handleCallError(e);
         } finally{
            this.spHideProcessing();
            this.processing = false;
         }
    }
}

export default Vue.component('ed-calls-info', EdCallsInfoComponent);
